import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { FormatCurrency, FormatPoints } from "../../../lib";
import { useUserData } from "../../../hooks/UserContext";
import { IoIosArrowForward } from "react-icons/io";
import notify from "../../../components/UI/toast";
import { useDispatch } from "react-redux";
import { removeItemCart } from "../../../Redux/cartSlice";
import Swal from "sweetalert2";
import { Box, Line, LabelName, SellerName } from "./styles";
import CartItem from "./CartItem";
import {useApp} from "../../../contexts/AppContext";
import { trackMarketplaceRemoveFromCart } from "../../../utils/gtm";
import { trackClick } from "../../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../../hooks/useScreenTracking";

export default function ListTabContent({
  items,
  tab,
  displayMode = "money",
  warning,
  shippingByBrandData,
}) {
  const screenName = useScreenTracking();
  const navigate = useNavigate();
  const swalCustom = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-primary order-0 btn-default-wl px-3 mb-2",
      cancelButton: "btn order-1 btn-cancel-wl px-3",
    },
    buttonsStyling: false,
    reverseButtons: true,
  });

  const { user, addressShipping, cartItemsError, setCartItemsError } =
    useUserData();


 
  const { whitelabel } = useApp();

  const dispatch = useDispatch();

  const [errorItemId, setErrorItemId] = useState(null);

  const handleQuantityError = useCallback((id) => setErrorItemId(id), []);
  const handleQuantityValid = useCallback((id) => {
    if (errorItemId === id) setErrorItemId(null);
  }, [errorItemId]);

  async function removeItem(sku, product, index) {
    swalCustom
      .fire({
        html: '<p class="fw-bold fs-5 mb-0">Deseja excluir este item?</p>',
        showCancelButton: true,
        confirmButtonText: "EXCLUIR",
        cancelButtonText: "CANCELAR",
        icon: "question",
        iconColor: whitelabel?.theme?.button_primary_color,
      })
      .then((result) => {
        if (result.isConfirmed) {
          trackClick({
            title: "remover-item",
            contentType: "checkout",
            screenName,
            tagId: tagIdFromLegacySuffix("15"),
          });

          const uuid = user.uuid
          const cep = addressShipping.cep || user.addresses[0].cep
          dispatch(removeItemCart({ sku, uuid, cep }))
            .unwrap()
            .then(() => {
              trackMarketplaceRemoveFromCart({
                product,
                itemId: product.uuid || product.id,
                itemName: product.short_description || product.label,
                price: parseFloat(product.price?.BRL?.offer || product.price?.BRL?.price || 0),
                quantity: product.quantity || 1,
                index: index,
                itemBrand: product.seller || product.brand?.label || "",
                itemCategory: product.category_name || "",
              });
              if (
                cartItemsError &&
                cartItemsError.item &&
                cartItemsError.item.id === (product.uuid || product.id)
              ) {
                setCartItemsError({});
              }
              notify("Sacola atualizada com sucesso", "success");
            });
        }
      });
  }

  const whoTab = (obj, index) => {
    let isVisible = false;
    const { BRL, points } = obj.price;
    if (index === "dinheiro" && Number(BRL.offer) > 0) {
      isVisible = true;
    }
    if (index === "pontos" && Number(points.offer) > 0) {
      isVisible = true;
    }
    return isVisible;
  };

  const getPrice = (price, tab) => {
    switch (tab) {
      case "money":
        return String(FormatCurrency(price.BRL.offer));
      case "points":
        return String(FormatPoints(price.points.offer));
      default:
        return "";
    }
  };

  const hasItemProblem = (uuid) => {
    if (warning) {
      return warning.some((val) =>
        val.items.some((item) => item.id === uuid)
      );
    }
    return false;
  };

  const groupedProducts = items.reduce((acc, item) => {
    if (!acc[item.brand_uuid]) {
      acc[item.brand_uuid] = [];
    }
    acc[item.brand_uuid].push({
      item: item,
      quantity: item.quantity,
    });

    return acc;
  }, {});

  function sumSubTotalByBrand(items, frete) {
    const result = {};

    items.forEach(({ item, quantity }) => {
      const brandId = item.item ? item.item.brand_uuid : item.brand_uuid;
      if (!result[brandId]) {
        result[brandId] = {
          totalBRL: 0,
          totalPoints: 0,
        };
      }

      result[brandId].totalBRL += (parseFloat(item.price.BRL.offer) * quantity);
      result[brandId].totalPoints += (parseInt(item.price.points.offer, 10) * quantity);
    });
    result[items[0].item.brand_uuid].totalBRL += frete.shipping_amount;
    result[items[0].item.brand_uuid].totalPoints += frete.shipping_point;

    return result;
  }

  return (
    <Box>
      {Object.keys(groupedProducts).map((brandUuid) => {        
        const brandItems = groupedProducts[brandUuid].filter((product) => {
          const result = whoTab(product.item, tab);
          return result;
        });
        const lastIndex = brandItems.length - 1;
        const subtotalByBrand = sumSubTotalByBrand(groupedProducts[brandUuid], shippingByBrandData[brandUuid]);

        const handleSellerClick = () => {
          trackClick({
            title: "clicar-seller-carrinho",
            contentType: "carrinho",
            screenName,
            tagId: tagIdFromLegacySuffix("15"),
          });
          navigate(`/loja/brands/${brandUuid}`);
        };

        return (
          <div key={brandUuid} className="mb-4">
            <SellerName
              className="font-wl-500 text-mg mb-1"
              style={{ cursor: "pointer" }}
              onClick={handleSellerClick}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleSellerClick();
                }
              }}
            >
              {brandItems[0]?.item?.seller || 'Marca'}
              <IoIosArrowForward />
            </SellerName>
            {brandItems.map((item, index) => (
              <React.Fragment key={item.item.uuid}>
                <CartItem
                  product={item.item}
                  quantity={item.quantity}
                  priceValue={getPrice(item.item.price, displayMode)}
                  index={index}
                  hasProblem={hasItemProblem(item.item.uuid)}
                  hasQuantityError={errorItemId === item.item.uuid}
                  onRemove={removeItem}
                  onQuantityError={handleQuantityError}
                  onQuantityValid={handleQuantityValid}
                />
                {index === lastIndex && (
                  <Row className="font-wl-500" style={{marginTop: '17px'}}>
                    <Col>
                      <LabelName className="color-text-dark text-sm mb-2">
                        Frete
                      </LabelName>
                    </Col>
                    <Col className="text-end">
                      {displayMode === "money" && (
                        <LabelName className="color-text-dark text-sm mb-2">
                          {FormatCurrency(
                            shippingByBrandData[brandUuid].shipping_amount
                          )}
                        </LabelName>
                      )}
                      {displayMode === "points" && (
                        <LabelName className="color-text-dark text-sm mb-2">
                          {FormatPoints(
                            shippingByBrandData[brandUuid].shipping_point
                          )}
                        </LabelName>
                      )}
                      {displayMode === "both" && (
                        <>
                          <LabelName className="color-text-dark text-sm mb-2">
                            {FormatCurrency(
                              shippingByBrandData[brandUuid].shipping_amount
                            )} Ou {shippingByBrandData[brandUuid].shipping_point} pts
                          </LabelName>
                        </>
                      )}
                    </Col>
                  </Row>
                )}
                {index === lastIndex && (
                  <Row className="font-wl-500">
                    <Col>
                      <LabelName className="text-sm mb-2">
                        Subtotal
                      </LabelName>
                    </Col>
                    <Col className="text-end">
                      {displayMode === "money" && (
                        <LabelName className="text-sm mb-2">
                          {FormatCurrency(
                            subtotalByBrand[brandUuid].totalBRL
                          )}
                        </LabelName>
                      )}
                      {displayMode === "points" && (
                        <LabelName className="color-text-dark text-sm mb-2">
                          {FormatPoints(
                            subtotalByBrand[brandUuid].totalPoints
                          )}
                        </LabelName>
                      )}
                      {displayMode === "both" && (
                        <>
                          <LabelName className="color-text-dark text-sm mb-2">
                            {FormatCurrency(
                              subtotalByBrand[brandUuid].totalBRL
                            )} Ou {FormatPoints(
                              subtotalByBrand[brandUuid].totalPoints
                            )} pts
                          </LabelName>
                        </>
                      )}
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            ))}
            <Line />
          </div>
        );
      })}
    </Box>
  );
}

ListTabContent.propTypes = {
  items: PropTypes.array,
  warning: PropTypes.array,
  tab: PropTypes.string,
  displayMode: PropTypes.oneOf(["money", "points", "both"]),
  shippingByBrandData: PropTypes.object,
};
